var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-whiteboard-slide text_block_section",class:`txt-dir-${_vm.textDir}`},[_c('div',{staticClass:"text_block h-100",class:`text-area txt-dir-${_vm.textDir}`,domProps:{"innerHTML":_vm._s(_vm.blockData.editorData)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }